import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { CreditCard } from "../state/types"

export const useCreditCardActions = () => {
    const saveActions = useSaveActions()

    const saveCreditCard = (creditCard: CreditCard) => {
        const { save } = saveActions()
        return save(TableName.CREDIT_CARDS, creditCard) as Promise<CreditCard>
    }

    const removeCreditCard = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.CREDIT_CARDS, id)
    }

    return {
        saveCreditCard,
        removeCreditCard
    }
}
